import styled from 'styled-components'

export const AcceptanceContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`
